import type { Store } from "@nwt/norce-pwa/dist/runtime/types/api/stores/stores";
import type { Warehouse } from "@nwt/norce-pwa/dist/runtime/types/api/warehouse/warehouse";
import { defineStore } from "pinia";

interface State {
	stores: Stores;
	fetchedStores: boolean;
	warehouses: Warehouse[];
}

type Stores = { [key: string]: Store[] };

export const useWarehousesAndStores = defineStore({
	id: "warehousesAndStores",
	state: (): State => ({
		warehouses: [],
		stores: {},
		fetchedStores: false
	}),
	actions: {
		setWarehouses(value: Warehouse[]) {
			this.warehouses = value;
		},
		setStores(value: Stores) {
			this.stores = value;
			this.fetchedStores = true;
		},
		setFetchedStores(value: boolean) {
			this.fetchedStores = value;
		}
	},
	getters: {
		getStores: (state) => state.stores
	},
	persist: {
		storage: persistedState.localStorage,
		pick: ["warehouses", "stores"]
	}
});
